import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import SideNav from './side-nav/SideNav';
import SegmentedTabsLayout from './tabs/SegmentedTabsLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderLayout = ({
  selectedNavItem,
  children
}) => {
  return /*#__PURE__*/_jsxs(PPUIGrid, {
    inlineSize: "100%",
    maxInlineSize: "1528px",
    margin: "auto",
    paddingBlockStart: "400",
    paddingInline: "200",
    gridTemplateAreas: " \". segmented-tabs\" \"side-nav content\" ",
    gridTemplateColumns: "minmax(280px, auto) 1fr",
    rowGap: "400",
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "segmented-tabs",
      children: /*#__PURE__*/_jsx(SegmentedTabsLayout, {
        selectedNavItem: selectedNavItem
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "side-nav",
      children: /*#__PURE__*/_jsx(SideNav, {
        selectedNavItem: selectedNavItem
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "content",
      children: children
    })]
  });
};
export default HeaderLayout;